import { useQuery } from "@tanstack/react-query";
import { useShallow } from "zustand/react/shallow";
import { useBoundStore } from "state/bound.store.js";
const fileCacherWorker = new ComlinkWorker<typeof import("workers/fileCacher.js")>(
  new URL("/src/workers/fileCacher.js", import.meta.url),
  {
    name: "calculationsComlink",
    type: "module",
  },
);

export const useFileCacher = () => {
  const { selectedItinerary } = useBoundStore(
    useShallow((s) => {
      return {
        selectedItinerary: s.selectedItinerary,
      };
    }),
  );

  const expensiveCalculationResult = useQuery({
    queryKey: ["fileCacherWorker", selectedItinerary?.updatedAt, selectedItinerary?.version],

    queryFn: () => fileCacherWorker.cacheFilesForItinerary(selectedItinerary?.v2 ?? []),
    staleTime: Infinity,
  });
  return expensiveCalculationResult;
};
